export const getLogoHref = (isAuthenticated: boolean) =>
  isAuthenticated ? '/dashboard' : '/signup';
